export default __webpack_public_path__ + "static/media/icon-orange-dot.94970a67.svg";